"use client";

import React from "react";

import { ClusterSelectionListSkeleton } from "./cluster-selection/cluster-selection-list-skeleton";
import { ClusterSelectionPanelLayout } from "./cluster-selection/cluster-selection-panel-layout";
import { ClusterSelectionSummarySkeleton } from "./cluster-selection/cluster-selection-summary-skeleton";
import { SCHOOL_CLUSTER_PANEL_DICTIONARY } from "./school-cluster-summary.constants";

export const SchoolClusterPanelSkeleton: React.FC = () => {
  return (
    <ClusterSelectionPanelLayout>
      <ClusterSelectionSummarySkeleton metricCount={1} />
      <ClusterSelectionListSkeleton
        showTrailingSkeleton
        sectionTitle={SCHOOL_CLUSTER_PANEL_DICTIONARY.schoolsByLevel}
      />
    </ClusterSelectionPanelLayout>
  );
};
